// extracted by mini-css-extract-plugin
export default {"PasswordResetEmailForm__submit":"yp_a bhf_qj bhf_to"};